import * as types from './types';
import { execApi, execApiWithParam } from '../api/apiActions';
import { closeAlertDialog, openSuccessDialog } from '../dialog/dialogActions';
import FamilyAccessApi from '../../apis/familyAccess';


export const chooseAccount = (accountId, successCb, errorCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.CHOOSE_ACCOUNT,
      api: FamilyAccessApi.chooseAccount,
      param: accountId,
      successCallback: response => {
        if (successCb) successCb(response);
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      errorCallback: response => {
        if (errorCb) errorCb(response);
      },
      useErrorDialog: true,
    }));
  };
};

export const createUser = (formValues) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.CREATE_USER,
      api: FamilyAccessApi.createUser,
      param: formValues,
      successCallback: response => {
        dispatch(openSuccessDialog({
          title: 'New User Created!',
          okCallback: () => {
            dispatch(closeAlertDialog());
            dispatch(getAccessUsers());
          },
        }));
      },
      useErrorDialog: true,
    }));
  };
};

export const deleteUser = (userId, successCb, errorCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.DELETE_USER,
      api: FamilyAccessApi.deleteUser,
      param: userId,
      successCallback: response => {
        if (successCb) successCb(response);
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      errorCallback: response => {
        if (errorCb) errorCb(response);
      },
      useErrorDialog: true,
    }));
  };
};

export const disableUser = (userId, successCb, errorCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.DISABLE_USER,
      api: FamilyAccessApi.disableUser,
      param: userId,
      successCallback: response => {
        if (successCb) successCb(response);
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      errorCallback: response => {
        if (errorCb) errorCb(response);
      },
      useErrorDialog: true,
    }));
  };
};

export const enableUser = (userId, successCb, errorCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.ENABLE_USER,
      api: FamilyAccessApi.enableUser,
      param: userId,
      successCallback: response => {
        if (successCb) successCb(response);
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      errorCallback: response => {
        if (errorCb) errorCb(response);
      },
      useErrorDialog: true,
    }));
  };
};

export const getAccounts = () => {
  return dispatch => {
    dispatch(execApi({
      type: types.GET_ACCOUNTS,
      api: FamilyAccessApi.getAccounts,
      successCallback: response => {
        dispatch({
          type: types.GET_ACCOUNTS,
          payload: response,
        });
      },
      useErrorDialog: true,
    }));
  };
};

export const getAccessUsers = () => {
  return dispatch => {
    dispatch(execApi({
      type: types.GET_ACCESS_USERS,
      api: FamilyAccessApi.getAccessUsers,
      successCallback: response => {
        dispatch({
          type: types.GET_ACCESS_USERS,
          payload: response.users,
        });
      },
      useErrorDialog: true,
    }));
  };
};

export const grantUserAccess = (formValues) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.GRANT_USER_ACCESS,
      api: FamilyAccessApi.grantUserAccess,
      param: formValues,
      successCallback: response => {
        dispatch(openSuccessDialog({
          title: 'Access Granted!',
          okCallback: () => {
            dispatch(closeAlertDialog());
            dispatch(getAccessUsers());
          },
        }));
      },
      useErrorDialog: true,
    }));
  };
};

export const removeExpiration = (id) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.REMOVE_EXPIRATION,
      api: FamilyAccessApi.removeExpiration,
      param: id,
      successCallback: response => {
        dispatch(openSuccessDialog({
          title: 'Expiration date removed.',
          okCallback: () => {
            dispatch(closeAlertDialog());
            dispatch(getAccessUsers());
          },
        }));
      },
      useErrorDialog: true,
    }));
  };
};

export const updateExpiration = (data) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.UPDATE_EXPIRATION,
      api: FamilyAccessApi.updateExpiration,
      param: data,
      successCallback: response => {
        dispatch(openSuccessDialog({
          title: 'Expiration date updated.',
          okCallback: () => {
            dispatch(closeAlertDialog());
            dispatch(getAccessUsers());
          },
        }));
      },
      useErrorDialog: true,
    }));
  };
};



// WEBPACK FOOTER //
// ./src/actions/familyAccess/familyAccessActions.js